/**
 * Copyright (c) 2010-2021 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
/**
 * Copyright (c) 2010-2021 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FetchWebWorkerProxy } from './fetch-web-worker.proxy';
import { FetchProxy } from './fetch.proxy';
import { HttpBackend } from '@angular/common/http';
import { HttpFetchBackend } from './http-fetch.backend';

@NgModule({
    declarations: [],
    imports: [CommonModule],
})
export class FetchModule {
    static forRoot(): ModuleWithProviders<FetchModule> {
        return {
            ngModule: FetchModule,
            providers: [
                { provide: FetchProxy, useClass: FetchWebWorkerProxy },
                { provide: HttpBackend, useClass: HttpFetchBackend },
            ],
        };
    }
}
